import bootbox from 'bootbox';
import { translateString } from '../../translations/gridTranslationHelper';

const bootboxAlert = (message, callback) => {
  bootbox.alert({
    message: message ?? 'Error',
    centerVertical: true,
    callback: callback,
    closeButton: false,
    backdrop: true
  });
}

const bootboxConfirm = (
  message,
  title,
  callback,
  size,
  culture
) => {
  bootbox.confirm({
    message: message ?? 'Error',
    centerVertical: true,
    title: title,
    buttons: {
      confirm: {
        label: translateString('rxg_Yes', culture),
        className: 'btn-primary',
      },
      cancel: {
        label: translateString('rxg_No', culture),
        className: 'btn-secondary',
      },
    },
    closeButton: title ? true : false,
    callback: callback,
    backdrop: true,
    size: size,
  });
};

const bootboxHide = () => bootbox.hideAll();

export { bootboxAlert, bootboxConfirm, bootboxHide }
